import React, { useEffect, useRef, useState } from "react";
import "../css/Carousel.css";
import colorSharp from "../assets/img/color-sharp-white.png";
import colorSharp2 from "../assets/img/color-sharp2-white.png";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

const Carousel = () => {
  const carouselRef = useRef(null);
  const sliderRef = useRef(null);
  const thumbnailBorderRef = useRef(null);
  const timeRef = useRef(null);

  const [photosMobileGallery, setPhotosMobileGallery] = useState([]);

  async function fetchMobileImages() {
    try {
      const projectRef = collection(db, "photoGallery");
      const q = query(projectRef,where("photoType", "==", "mobile")); 
      const querySnap = await getDocs(q);
      let projects = [];
      querySnap.forEach((doc) => {
        projects.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setPhotosMobileGallery(projects);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchMobileImages();
  }, []);

  const [photosDesktopGallery, setPhotosDesktopGallery] = useState([]);

  async function fetchDesktopImages() {
    try {
      const projectRef = collection(db, "photoGallery");
      const q = query(projectRef,where("photoType", "==", "desktop")); 
      const querySnap = await getDocs(q);
      let projects = [];
      querySnap.forEach((doc) => {
        projects.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setPhotosDesktopGallery(projects);
      console.log(projects);

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchDesktopImages();
  }, []);

  useEffect(() => {
    const nextDom = document.getElementById("next");
    const prevDom = document.getElementById("prev");

    let thumbnailBorderDom = document.querySelector(".carousel .thumbnail");
    if (!thumbnailBorderDom) {
      console.error("Thumbnail border element not found");
      return;
    }

    let thumbnailItemsDom = Array.from(
      thumbnailBorderDom.querySelectorAll(".item")
    );
    if (thumbnailItemsDom.length === 0) {
      console.error("No thumbnail items found");
      return;
    }

    thumbnailBorderDom.appendChild(thumbnailItemsDom[0]);

    let timeRunning = 3000;
    let timeAutoNext = 7000;
    let runTimeOut;
    let runNextAuto = setTimeout(() => {
      nextDom.click();
    }, timeAutoNext);

    const showSlider = (type) => {
      const sliderItems = Array.from(
        sliderRef.current.querySelectorAll(".carousel .list .item")
      );
      const thumbnailItems = Array.from(
        thumbnailBorderRef.current.querySelectorAll(".item")
      );

      if (sliderItems.length === 0 || thumbnailItems.length === 0) {
        console.error("No slider or thumbnail items found");
        return;
      }

      if (type === "next") {
        sliderRef.current.appendChild(sliderItems[0]);
        thumbnailBorderRef.current.appendChild(thumbnailItems[0]);
        carouselRef.current.classList.add("next");
      } else {
        sliderRef.current.prepend(sliderItems[sliderItems.length - 1]);
        thumbnailBorderRef.current.prepend(
          thumbnailItems[thumbnailItems.length - 1]
        );
        carouselRef.current.classList.add("prev");
      }

      clearTimeout(runTimeOut);
      runTimeOut = setTimeout(() => {
        carouselRef.current.classList.remove("next");
        carouselRef.current.classList.remove("prev");
      }, timeRunning);

      clearTimeout(runNextAuto);
      runNextAuto = setTimeout(() => {
        nextDom.click();
      }, timeAutoNext);
    };

    nextDom.onclick = () => {
      showSlider("next");
    };

    prevDom.onclick = () => {
      showSlider("prev");
    };

    return () => {
      clearTimeout(runNextAuto);
      clearTimeout(runTimeOut);
    };
  }, [photosDesktopGallery,photosMobileGallery]);

  
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="photoGallery" id="photoGallery">
      <div className="" style={{ width: "90vw", margin: "auto" }}>
        <div className="col-12">
          <div className="gallery-bx wow zoomIn">
            <div className="about-section" style={{ marginBottom: "30px" }}>
              <h1 className="background-text">GALLERY</h1>
              <h1 className="foreground-text" style={{ color: "white",fontWeight:800 }}>
                PHOTO
                <div
                  className="underline"
                  style={{ backgroundColor: "white" }}
                ></div>
              </h1>
            </div>

            {
              isMobile ? (
                <div>
              <div
                className="carousel"
                ref={carouselRef}
               
              >
                <div className="list" ref={sliderRef}>
                  {photosMobileGallery.map((image, index) => (
                    <div className="item" key={index}>
                      <img
                        src={image.data.PhotoGalleryImage}
                        alt={`Slide ${index + 1}`}
                      />
                      <div className="content">
                        <div className="topic">
                          {image.data.photoGalleryName}
                        </div>
                        <div className="author">
                          {image.data.photoGalleryDescription}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="thumbnail" ref={thumbnailBorderRef}>
                  {photosMobileGallery.map((image, index) => (
                    <div className="item" key={index}>
                      <img
                        src={image.data.PhotoGalleryImage}
                        alt={`Thumbnail ${index + 1}`}
                      />
                    </div>
                  ))}
                </div>
                <div className="arrows">
                  <button id="prev">&lt;</button>
                  <button id="next">&gt;</button>
                </div>
                <div className="time" ref={timeRef}></div>
              </div>
            </div>
              ) :
              (
                <div>
              <div
                className="carousel"
                ref={carouselRef}
    
              >
                <div className="list" ref={sliderRef}>
                  {photosDesktopGallery.map((image, index) => (
                    <div className="item" key={index}>
                      <img
                        src={image.data.PhotoGalleryImage}
                        alt={`Slide ${index + 1}`}
                      />
                      <div className="content">
                        <div className="topic">
                          {image.data.photoGalleryName}
                        </div>
                        <div className="author">
                          {image.data.photoGalleryDescription}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="thumbnail" ref={thumbnailBorderRef}>
                  {photosDesktopGallery.map((image, index) => (
                    <div className="item" key={index}>
                      <img
                        src={image.data.PhotoGalleryImage}
                        alt={`Thumbnail ${index + 1}`}
                      />
                    </div>
                  ))}
                </div>
                <div className="arrows">
                  <button id="prev">&lt;</button>
                  <button id="next">&gt;</button>
                </div>
                <div className="time" ref={timeRef}></div>
              </div>
            </div>
              )
            }



          </div>


        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
      <img className="background-image-right" src={colorSharp2} alt="Image" />
    </section>
  );
};

export default Carousel;
